import { carouselProduct } from '../product-details/queries';

export const carouselProductsQuery = `
  query GetCarouselProducts($locale: Locale, $identifiers: [ProductIdentifier!]!) {
    products: carouselProducts(locale: $locale, identifiers: $identifiers) {
        ${carouselProduct}
    }
  }
`;

export const recommendedProductsQuery = `
  query GetRecommendedProducts($locale: Locale, $sku: String!, $type: RecommendationType!) {
    products: recommendedProducts(locale: $locale, sku: $sku, type: $type) {
        ${carouselProduct}
    }
  }
`;
